export default __webpack_public_path__ + "static/sloth_card_3-2e85a1faea44d55de14002ffaf067a86.png";